import React from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink } from "react-router-dom";
import { Avatar, Card, Col, Icon, Row } from 'antd';
import BalanceComponent from '../../components/Balance/BalanceComponent';
import LevelBoxComponent from '../../components/LevelBox/LevelBoxComponent';
import HideInfoBoxComponent from '../../components/HideInfoBox/HideInfoBoxComponent';
import ModalInfoComponent from '../../components/Modal/ModalInfoComponent';
import Loader from '../../components/common/Loader';
import DashboardBookings from './DashboardBookings';
import { setIcon } from '../../services/setIcon';
import './style.css';


const { Meta } = Card;

const DashboardPage = ({
  pastBooking,
  upcomingBooking,
  modals,
  hideModal,
  loy3MembershipInfo,
  loy3User,
  isLoadingProfile,
  isLoadingBookings,
  brandDetails,
}, context) => {

  const isVisible = (modalId) => modals.showingUp[modalId] || false;
  const authenticated = Boolean(loy3MembershipInfo);
  const notMember = (loy3User && !loy3User.memberShipName) || (!loy3User);
  const { brandName = '', brandCode = '' } = brandDetails || {};

  if (isLoadingProfile) {
    return (
      <Loader fullScreen>
        {context.t('Please wait while we load your profile information')}
      </Loader>
    );
  }

  return (
      <div className="pt-6">
      {loy3User && authenticated &&
        <React.Fragment>
          <Row gutter={24} className="h-lg">
            <Col span={24}>
              <h2 className="App-link mt-3 ml-3">
                <NavLink to="/profile" exact activeClassName="active">
                  {context.t('Edit my profile')}
                  &nbsp;<Icon component={setIcon('edit')}/>
                </NavLink>
              </h2>
              <h3 className="sub-title m-3 mb-0">
                {loy3User.firstName} &nbsp; {loy3User.lastName}
              </h3>
            </Col>
          </Row>

          <Row gutter={24} type="flex">
            <Col lg={6} xs={24} className="h-md elem-stretch d-sm-block">
              <Card className="card-profile">
                <h2 className="cursor-pointer hover:text-highlight">
                  <NavLink to="/profile" exact activeClassName="active">
                    {context.t('Edit my profile')}
                    &nbsp;<Icon className="align-baseline" component={setIcon('edit')}/>
                  </NavLink>
                </h2>
                <Meta
                  title={`${loy3User.firstName} ${loy3User.lastName}`}
                  description={loy3MembershipInfo?.cardCode}
                  avatar={
                    <Avatar src={loy3User.profilePic} size={64} />
                  }
                />
              </Card>
            </Col>

            <Col lg={18} md={24} xs={24}>
              {!authenticated &&
                <HideInfoBoxComponent
                  text={context.t('join {brandCode} as member and get access to our exclusive offers and benefits!', { brandCode })}
                  action="" />
              }
              <Row gutter={24} type="flex">
                <Col lg={14} md={13} xs={24} className="elem-stretch d-sm-block">
                  <LevelBoxComponent
                    loy3MembershipInfo={loy3MembershipInfo}
                    currentLevel={loy3User.memberShipName}
                  />
                </Col>
                <Col lg={10} md={11} xs={24}>
                  <Link to="/wallet" className="font-semibold text-orange-primary inline">
                    <Card className={`card-wallet ${notMember && 'disabled'}`} hoverable>
                      <h2 className="sub-title p-0 m-0">{context.t('YOUR WALLET')}</h2>
                      <BalanceComponent coins={loy3MembershipInfo.memberPoints ? loy3MembershipInfo.memberPoints.totalPoints : 0}/>
                    </Card>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </React.Fragment>
      }
      <DashboardBookings
        isLoading={isLoadingBookings}
        loy3User={loy3User}
        past={pastBooking}
        upcoming={upcomingBooking}
        context={context}
      />

      <ModalInfoComponent
        title={context.t('Plan your next vacation!')}
        content={context.t("Don't miss out on our exclusive offers for you. Pick your dates for your next vacation with {brandName}.", { brandName })}
        cancelText={context.t('Not now, thanks')}
        okText={context.t('OK, book now')}
        id="noBooking"
        onOk={() => hideModal('noBooking')}
        onCancel={() => hideModal('noBooking')}
        onVisible={isVisible('noBooking')}
        icon="date"
      />
    </div>
  );
};

DashboardPage.propTypes = {
  header: PropTypes.string.isRequired,
  pastBooking: PropTypes.object,
  upcomingBooking: PropTypes.object,
  isLoadingBookings: PropTypes.bool,
  modals: PropTypes.object,
  hideModal: PropTypes.func,
  showModal: PropTypes.func,
  loy3MembershipInfo: PropTypes.object,
  loy3User: PropTypes.object,
  brandDetails: PropTypes.object,
}

DashboardPage.contextTypes = {
  t: PropTypes.func.isRequired,
}

export default DashboardPage;
